import { AsyncSelectField, AsyncSelectFieldProps } from "../../inputFields/AsyncSelectField";
import { UseControllerProps } from "react-hook-form";
import { useController } from "react-hook-form";

export interface FormAsyncSelectFieldProps<
	TFieldValues extends object,
	TOption,
	Key extends string | number,
> extends Omit<AsyncSelectFieldProps<TOption, Key>, "onChange" | "value"> {
	control: UseControllerProps<TFieldValues>["control"];
	name: UseControllerProps<TFieldValues>["name"];
	rules?: UseControllerProps<TFieldValues>["rules"];
}

export const FormAsyncSelectField = <
	TFieldValues extends object,
	TOption,
	Key extends string | number,
>({
	control,
	name,
	rules,
	fetchOptions,
	getOptionKey,
	...other
}: FormAsyncSelectFieldProps<TFieldValues, TOption, Key>) => {
	const { field, fieldState } = useController({
		name,
		control,
		rules,
	});

	const transformedField = {
		...field,
		ref: undefined,
		onChange: (v: TOption | null) => {
			if (v == null) field.onChange(null);
			else field.onChange(getOptionKey(v));
		},
	};

	return (
		<AsyncSelectField
			fetchOptions={fetchOptions}
			error={fieldState.error?.message}
			getOptionKey={getOptionKey}
			{...transformedField}
			{...other}
		/>
	);
};
